import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { colors, useAtSize } from '@fs/zion-ui'
import ChurchLogo from './ChurchLogo'
import { useDataContext } from '../../services/data-service'

const footerCss = css`
  color: ${colors.text.secondary};
  font-size: 12px;
  line-height: 1.33;
  min-height: 80px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const churchLogoCss = css`
  position: relative;
  margin-left: 24px;
`

export default function AncestorsFooter(): JSX.Element {
  const {
    store: { CF = false },
  } = useDataContext()
  const [t] = useTranslation()
  const atSize = useAtSize()
  const isMobile = atSize({ default: true, lg: false })
  const termsPrivacyText = CF
    ? t(
        'ancestors.terms-privacy.restricted-text',
        'FamilySearch Terms of Use (Updated 2019-12-10) | Privacy Notice (Updated 2021-04-06)'
      )
    : t(
        'ancestors.terms-privacy.text',
        '<a href="https://www.familysearch.org/legal/terms">FamilySearch Terms of Use</a> (Updated 2019-12-10) | <a href="https://www.familysearch.org/legal/privacy">Privacy Notice</a> (Updated 2021-04-06)'
      )
  const intellectualReserveText = CF
    ? t(
        'ancestors.intellectual-reserve.restricted-text',
        '© 2021 by Intellectual Reserve, Inc. All rights reserved. A service provided by The Church of Jesus Christ of Latter-day Saints!'
      )
    : t(
        'ancestors.intellectual-reserve.text',
        '© 2021 by Intellectual Reserve, Inc. All rights reserved. A service provided by <a href="http://churchofjesuschrist.org">The Church of Jesus Christ of Latter-day Saints</a>'
      )

  return (
    <footer css={footerCss}>
      <div>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: termsPrivacyText }}
        />
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: intellectualReserveText }}
        />
      </div>
      {!isMobile && (
        <div css={churchLogoCss}>
          <ChurchLogo restricted={CF} />
        </div>
      )}
    </footer>
  )
}
